export default "__VITE_ASSET__4e0ca18f__"